/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 public/models/people.glb --transform
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('./models/people-transformed.glb')
  return (
    <group {...props} dispose={null}>
        <mesh geometry={nodes.Man05_0057D0_0.geometry} rotation={[-Math.PI / 2, 0, 0.58]} >
            <meshBasicMaterial depthTest={false} color={'rgb(242, 97, 63)'}/>
        </mesh>
    </group>
  )
}

useGLTF.preload('./models/people-transformed.glb')
